module.exports = __webpack_public_path__ + "assets/img/3.9681e1f8.png";